import home1 from "@assets/images/home1.png";
import home2 from "@assets/images/home2.png";
import { Icon } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { routes } from "@routes";

export function HomeInfos() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();

  return (
    <div className="flex flex-col gap-10 bg-white">
      <div className="w-full max-w-[936px] mx-auto px-5 lg:px-0 py-10 md:py-28 flex flex-col gap-14 md:gap-32">
        <div className="flex flex-col md:flex-row gap-10 md:items-start">
          <img src={home1} className="w-full md:max-w-[52%] shrink-0" />
          <div className="flex flex-col gap-10">
            <h2 className="font-jakarta text-blue-medium text-[32px] lg:text-[40px] leading-[36px] md:leading-[48px]">
              {t("home.facilitatedTransport")}
            </h2>
            <div className="flex flex-col gap-4">
              <p className="text-text-strong text-[14px] lg:text-[16px]">
                {t("home.facilityDescription1")}
              </p>
              <p className="text-text-strong text-[14px] lg:text-[16px]">
                {t("home.facilityDescription2")}
              </p>
            </div>
            <div
              onClick={() => navigate(`${routes.SEARCH}?${search}`)}
              className=" cursor-pointer flex items-center gap-2 text-blue-medium font-bold font-jakarta text-[14px] lg:text-[16px]"
            >
              <Icon src="arrow_right_line" color="#0C419A" />
              {t("home.bookYourJourney")}
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-10 md:items-start">
          <img
            src={home2}
            className="w-full md:max-w-[52%] shrink-0 order-1 md:order-3"
          />
          <div className="flex flex-col gap-10 order-2">
            <h2 className="font-jakarta text-blue-medium text-[32px] lg:text-[40px] leading-[36px] md:leading-[48px]">
              {t("home.simpleQuickEconomical")}
            </h2>
            <div className="flex flex-col gap-4">
              <p className="text-text-strong text-[14px] lg:text-[16px]">
                {t("home.simpleDescription1")}
              </p>
              <p className="text-text-strong text-[14px] lg:text-[16px]">
                {t("home.simpleDescription2")}
              </p>
            </div>
            <div
              onClick={() => navigate(`${routes.SEARCH}?${search}`)}
              className="cursor-pointer flex items-center gap-2 text-blue-medium font-bold font-jakarta text-[14px] lg:text-[16px]"
            >
              <Icon src="arrow_right_line" color="#0C419A" />
              {t("home.bookYourJourney")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
